import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GripVertical = createReactComponent("GripVertical", ["svg", defaultAttributes, [["circle", {
  cx: "9",
  cy: "12",
  r: "1",
  key: "150moy"
}], ["circle", {
  cx: "9",
  cy: "5",
  r: "1",
  key: "xcz4l0"
}], ["circle", {
  cx: "9",
  cy: "19",
  r: "1",
  key: "pyqsqx"
}], ["circle", {
  cx: "15",
  cy: "12",
  r: "1",
  key: "4recin"
}], ["circle", {
  cx: "15",
  cy: "5",
  r: "1",
  key: "viq9zd"
}], ["circle", {
  cx: "15",
  cy: "19",
  r: "1",
  key: "7hp0b8"
}]]]);
export default GripVertical;